module.exports = __webpack_public_path__ + "img/toplogo.e9c131a6.jpg";